/**
 * 사업자 메뉴 관리 페이지
 * 메뉴 → 권한 → 대상 API URL 3단 계층 구조
 */
import { useState, useEffect, useCallback } from 'react';
// TODO: 저장/삭제 버튼 활성화 시 주석 해제
// import { Plus, Trash2, Save, ChevronRight, Layers, ShieldCheck, Link } from 'lucide-react';
import { ChevronRight, Layers, ShieldCheck, Link } from 'lucide-react';
import {
  adminBusinessMenuApi,
  AdminBusinessMenu,
  AdminBusinessMenuPermission,
  AdminBusinessMenuTargetUrl,
} from '../../services/api/adminBusinessMenu';
import { PageHeader } from '@/components/common';

// ─── TODO: 저장/삭제 버튼 활성화 시 주석 해제 ────────────────────────────────
// const emptyMenu = (): AdminBusinessMenu => ({ menuSeq: null, menuName: '' });
//
// const emptyPermission = (menuSeq: number | null): AdminBusinessMenuPermission => ({
//   permissionsSeq: null,
//   menuSeq,
//   permissionsName: '',
//   permissionsValue: '',
//   valueType: '',
// });
//
// const emptyTargetUrl = (permissionsSeq: number | null): AdminBusinessMenuTargetUrl => ({
//   url: '',
//   method: 'GET',
//   description: '',
//   permissionsSeq,
// });
//
// const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

// ─── 메인 컴포넌트 ────────────────────────────────────────────────────────────

export function BusinessMenuPage() {
  // ── 메뉴 상태
  const [menus, setMenus] = useState<AdminBusinessMenu[]>([]);
  const [menuLoading, setMenuLoading] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState<AdminBusinessMenu | null>(null);
  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const [menuForm, setMenuForm] = useState<AdminBusinessMenu>(emptyMenu());
  // const [menuFormMode, setMenuFormMode] = useState<'create' | 'edit' | null>(null);

  // ── 권한 상태
  const [permissions, setPermissions] = useState<AdminBusinessMenuPermission[]>([]);
  const [permLoading, setPermLoading] = useState(false);
  const [selectedPerm, setSelectedPerm] = useState<AdminBusinessMenuPermission | null>(null);
  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const [permForm, setPermForm] = useState<AdminBusinessMenuPermission>(emptyPermission(null));
  // const [permFormMode, setPermFormMode] = useState<'create' | 'edit' | null>(null);

  // ── 대상 URL 상태
  const [targetUrls, setTargetUrls] = useState<AdminBusinessMenuTargetUrl[]>([]);
  const [urlLoading, setUrlLoading] = useState(false);
  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const [urlForm, setUrlForm] = useState<AdminBusinessMenuTargetUrl>(emptyTargetUrl(null));
  // const [urlFormMode, setUrlFormMode] = useState<'create' | 'edit' | null>(null);
  // const [urlEditIndex, setUrlEditIndex] = useState<number | null>(null);

  // ─── 메뉴 로드 ──────────────────────────────────────────────────────────────
  const fetchMenus = useCallback(async () => {
    setMenuLoading(true);
    try {
      const data = await adminBusinessMenuApi.getMenus();
      setMenus(data ?? []);
    } catch (e) {
      console.error('메뉴 조회 실패', e);
    } finally {
      setMenuLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMenus();
  }, [fetchMenus]);

  // ─── 권한 로드 ──────────────────────────────────────────────────────────────
  const fetchPermissions = useCallback(async (menuSeq: number) => {
    setPermLoading(true);
    setSelectedPerm(null);
    setTargetUrls([]);
    try {
      const data = await adminBusinessMenuApi.getPermissions(menuSeq);
      setPermissions(data ?? []);
    } catch (e) {
      console.error('권한 조회 실패', e);
    } finally {
      setPermLoading(false);
    }
  }, []);

  // ─── 대상 URL 로드 ──────────────────────────────────────────────────────────
  const fetchTargetUrls = useCallback(async (permissionsSeq: number) => {
    setUrlLoading(true);
    try {
      const data = await adminBusinessMenuApi.getTargetUrls(permissionsSeq);
      setTargetUrls(data ?? []);
    } catch (e) {
      console.error('대상 URL 조회 실패', e);
    } finally {
      setUrlLoading(false);
    }
  }, []);

  // ─── 메뉴 핸들러 ────────────────────────────────────────────────────────────
  const handleSelectMenu = (menu: AdminBusinessMenu) => {
    setSelectedMenu(menu);
    if (menu.menuSeq) fetchPermissions(menu.menuSeq);
  };

  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const handleMenuSave = async () => {
  //   if (!menuForm.menuName.trim()) return alert('메뉴명을 입력하세요.');
  //   try {
  //     await adminBusinessMenuApi.saveMenu(menuForm);
  //     await fetchMenus();
  //     setMenuFormMode(null);
  //     setMenuForm(emptyMenu());
  //   } catch (e) {
  //     console.error('메뉴 저장 실패', e);
  //     alert('저장에 실패했습니다.');
  //   }
  // };
  //
  // const handleMenuDelete = async (menu: AdminBusinessMenu) => {
  //   if (!window.confirm(`"${menu.menuName}" 메뉴를 삭제하시겠습니까?`)) return;
  //   try {
  //     await adminBusinessMenuApi.deleteMenu(menu);
  //     if (selectedMenu?.menuSeq === menu.menuSeq) {
  //       setSelectedMenu(null);
  //       setPermissions([]);
  //       setTargetUrls([]);
  //     }
  //     await fetchMenus();
  //   } catch (e) {
  //     console.error('메뉴 삭제 실패', e);
  //     alert('삭제에 실패했습니다.');
  //   }
  // };

  // ─── 권한 핸들러 ────────────────────────────────────────────────────────────
  const handleSelectPerm = (perm: AdminBusinessMenuPermission) => {
    setSelectedPerm(perm);
    if (perm.permissionsSeq) fetchTargetUrls(perm.permissionsSeq);
  };

  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const handlePermSave = async () => {
  //   if (!permForm.permissionsName.trim()) return alert('권한명을 입력하세요.');
  //   if (!permForm.permissionsValue.trim()) return alert('권한값을 입력하세요.');
  //   if (!permForm.valueType.trim()) return alert('값 타입을 입력하세요.');
  //   try {
  //     await adminBusinessMenuApi.savePermissions([permForm]);
  //     if (selectedMenu?.menuSeq) await fetchPermissions(selectedMenu.menuSeq);
  //     setPermFormMode(null);
  //     setPermForm(emptyPermission(selectedMenu?.menuSeq ?? null));
  //   } catch (e) {
  //     console.error('권한 저장 실패', e);
  //     alert('저장에 실패했습니다.');
  //   }
  // };
  //
  // const handlePermDelete = async (perm: AdminBusinessMenuPermission) => {
  //   if (!window.confirm(`"${perm.permissionsName}" 권한을 삭제하시겠습니까?`)) return;
  //   try {
  //     await adminBusinessMenuApi.deletePermissions([perm]);
  //     if (selectedPerm?.permissionsSeq === perm.permissionsSeq) {
  //       setSelectedPerm(null);
  //       setTargetUrls([]);
  //     }
  //     if (selectedMenu?.menuSeq) await fetchPermissions(selectedMenu.menuSeq);
  //   } catch (e) {
  //     console.error('권한 삭제 실패', e);
  //     alert('삭제에 실패했습니다.');
  //   }
  // };

  // ─── 대상 URL 핸들러 ────────────────────────────────────────────────────────
  // TODO: 저장/삭제 버튼 활성화 시 주석 해제
  // const handleUrlSave = async () => {
  //   if (!urlForm.url.trim()) return alert('URL을 입력하세요.');
  //   if (!urlForm.description.trim()) return alert('설명을 입력하세요.');
  //   try {
  //     await adminBusinessMenuApi.saveTargetUrls([urlForm]);
  //     if (selectedPerm?.permissionsSeq) await fetchTargetUrls(selectedPerm.permissionsSeq);
  //     setUrlFormMode(null);
  //     setUrlEditIndex(null);
  //     setUrlForm(emptyTargetUrl(selectedPerm?.permissionsSeq ?? null));
  //   } catch (e) {
  //     console.error('URL 저장 실패', e);
  //     alert('저장에 실패했습니다.');
  //   }
  // };
  //
  // const handleUrlDelete = async (targetUrl: AdminBusinessMenuTargetUrl) => {
  //   if (!window.confirm(`"${targetUrl.url}" URL을 삭제하시겠습니까?`)) return;
  //   try {
  //     await adminBusinessMenuApi.deleteTargetUrls([targetUrl]);
  //     if (selectedPerm?.permissionsSeq) await fetchTargetUrls(selectedPerm.permissionsSeq);
  //   } catch (e) {
  //     console.error('URL 삭제 실패', e);
  //     alert('삭제에 실패했습니다.');
  //   }
  // };

  // ─── 렌더링 ─────────────────────────────────────────────────────────────────
  return (
    <div className="space-y-4">
      <PageHeader
        title="사업자 메뉴 관리"
        subtitle="메뉴 → 권한 → 대상 API URL 순서로 관리합니다."
      />

      {/* 3단 패널 */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">

        {/* ── 1단: 메뉴 목록 ── */}
        <PanelCard
          icon={<Layers size={16} />}
          title="메뉴 목록"
          // TODO: 저장/삭제 버튼 활성화 시 onAdd 주석 해제
          // onAdd={() => { setMenuFormMode('create'); setMenuForm(emptyMenu()); }}
        >
          {menuLoading ? (
            <LoadingRow />
          ) : menus.length === 0 ? (
            <EmptyRow text="등록된 메뉴가 없습니다." />
          ) : (
            <ul className="divide-y divide-gray-100">
              {menus.map(menu => (
                <li
                  key={menu.menuSeq}
                  className={`flex cursor-pointer items-center justify-between px-4 py-3 hover:bg-gray-50 ${
                    selectedMenu?.menuSeq === menu.menuSeq ? 'bg-primary-50' : ''
                  }`}
                  onClick={() => handleSelectMenu(menu)}
                >
                  <div className="flex items-center gap-2 min-w-0">
                    <ChevronRight
                      size={14}
                      className={`flex-shrink-0 text-gray-400 transition-transform ${
                        selectedMenu?.menuSeq === menu.menuSeq ? 'rotate-90 text-primary-600' : ''
                      }`}
                    />
                    <span className="truncate text-sm font-medium text-gray-800">
                      {menu.menuName}
                    </span>
                  </div>
                  {/* TODO: 저장/삭제 버튼 임시 숨김
                  <div className="flex flex-shrink-0 gap-1 ml-2">
                    <ActionButton icon={<Save size={13} />} title="수정" onClick={e => { e.stopPropagation(); setMenuForm({ ...menu }); setMenuFormMode('edit'); }} />
                    <ActionButton icon={<Trash2 size={13} />} title="삭제" danger onClick={e => { e.stopPropagation(); handleMenuDelete(menu); }} />
                  </div>
                  */}
                </li>
              ))}
            </ul>
          )}

          {/* TODO: 저장/삭제 버튼 활성화 시 주석 해제
          {menuFormMode && (
            <InlineForm
              title={menuFormMode === 'create' ? '메뉴 추가' : '메뉴 수정'}
              onSave={handleMenuSave}
              onCancel={() => setMenuFormMode(null)}
            >
              <FormInput label="메뉴명" value={menuForm.menuName} onChange={v => setMenuForm(prev => ({ ...prev, menuName: v }))} placeholder="예) 예약 관리" />
            </InlineForm>
          )}
          */}
        </PanelCard>

        {/* ── 2단: 권한 목록 ── */}
        <PanelCard
          icon={<ShieldCheck size={16} />}
          title={selectedMenu ? `권한 목록 — ${selectedMenu.menuName}` : '권한 목록'}
          disabled={!selectedMenu}
          // TODO: 저장/삭제 버튼 활성화 시 onAdd 주석 해제
          // onAdd={selectedMenu ? () => { setPermFormMode('create'); setPermForm(emptyPermission(selectedMenu.menuSeq)); } : undefined}
        >
          {!selectedMenu ? (
            <EmptyRow text="메뉴를 먼저 선택하세요." />
          ) : permLoading ? (
            <LoadingRow />
          ) : permissions.length === 0 ? (
            <EmptyRow text="등록된 권한이 없습니다." />
          ) : (
            <ul className="divide-y divide-gray-100">
              {permissions.map(perm => (
                <li
                  key={perm.permissionsSeq}
                  className={`flex cursor-pointer items-center justify-between px-4 py-3 hover:bg-gray-50 ${
                    selectedPerm?.permissionsSeq === perm.permissionsSeq ? 'bg-primary-50' : ''
                  }`}
                  onClick={() => handleSelectPerm(perm)}
                >
                  <div className="flex items-center gap-2 min-w-0">
                    <ChevronRight
                      size={14}
                      className={`flex-shrink-0 text-gray-400 transition-transform ${
                        selectedPerm?.permissionsSeq === perm.permissionsSeq
                          ? 'rotate-90 text-primary-600'
                          : ''
                      }`}
                    />
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-gray-800">
                        {perm.permissionsName}
                      </p>
                      <p className="truncate text-xs text-gray-400">
                        {perm.permissionsValue} · {perm.valueType}
                      </p>
                    </div>
                  </div>
                  {/* TODO: 저장/삭제 버튼 임시 숨김
                  <div className="flex flex-shrink-0 gap-1 ml-2">
                    <ActionButton icon={<Save size={13} />} title="수정" onClick={e => { e.stopPropagation(); setPermForm({ ...perm }); setPermFormMode('edit'); }} />
                    <ActionButton icon={<Trash2 size={13} />} title="삭제" danger onClick={e => { e.stopPropagation(); handlePermDelete(perm); }} />
                  </div>
                  */}
                </li>
              ))}
            </ul>
          )}

          {/* TODO: 저장/삭제 버튼 활성화 시 주석 해제
          {permFormMode && (
            <InlineForm
              title={permFormMode === 'create' ? '권한 추가' : '권한 수정'}
              onSave={handlePermSave}
              onCancel={() => setPermFormMode(null)}
            >
              <FormInput label="권한명" value={permForm.permissionsName} onChange={v => setPermForm(prev => ({ ...prev, permissionsName: v }))} placeholder="예) 예약 조회" />
              <FormInput label="권한값" value={permForm.permissionsValue} onChange={v => setPermForm(prev => ({ ...prev, permissionsValue: v }))} placeholder="예) reservation:read" />
              <FormInput label="값 타입" value={permForm.valueType} onChange={v => setPermForm(prev => ({ ...prev, valueType: v }))} placeholder="예) ROLE" />
            </InlineForm>
          )}
          */}
        </PanelCard>

        {/* ── 3단: 대상 URL 목록 ── */}
        <PanelCard
          icon={<Link size={16} />}
          title={selectedPerm ? `대상 API URL — ${selectedPerm.permissionsName}` : '대상 API URL'}
          disabled={!selectedPerm}
          // TODO: 저장/삭제 버튼 활성화 시 onAdd 주석 해제
          // onAdd={selectedPerm ? () => { setUrlFormMode('create'); setUrlEditIndex(null); setUrlForm(emptyTargetUrl(selectedPerm.permissionsSeq)); } : undefined}
        >
          {!selectedPerm ? (
            <EmptyRow text="권한을 먼저 선택하세요." />
          ) : urlLoading ? (
            <LoadingRow />
          ) : targetUrls.length === 0 ? (
            <EmptyRow text="등록된 URL이 없습니다." />
          ) : (
            <ul className="divide-y divide-gray-100">
              {targetUrls.map((tu, idx) => (
                <li key={idx} className="px-4 py-3 hover:bg-gray-50">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <MethodBadge method={tu.method} />
                        <span className="truncate text-xs font-mono text-gray-700">{tu.url}</span>
                      </div>
                      {tu.description && (
                        <p className="mt-0.5 truncate text-xs text-gray-400">{tu.description}</p>
                      )}
                    </div>
                    {/* TODO: 저장/삭제 버튼 임시 숨김
                    <div className="flex flex-shrink-0 gap-1">
                      <ActionButton icon={<Save size={13} />} title="수정" onClick={() => { setUrlForm({ ...tu }); setUrlFormMode('edit'); setUrlEditIndex(idx); }} />
                      <ActionButton icon={<Trash2 size={13} />} title="삭제" danger onClick={() => handleUrlDelete(tu)} />
                    </div>
                    */}
                  </div>
                </li>
              ))}
            </ul>
          )}

          {/* TODO: 저장/삭제 버튼 활성화 시 주석 해제
          {urlFormMode && (
            <InlineForm
              title={urlFormMode === 'create' ? 'URL 추가' : 'URL 수정'}
              onSave={handleUrlSave}
              onCancel={() => { setUrlFormMode(null); setUrlEditIndex(null); }}
            >
              <FormInput label="URL" value={urlForm.url} onChange={v => setUrlForm(prev => ({ ...prev, url: v }))} placeholder="예) /business/reserve/list" />
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">HTTP 메서드</label>
                <select value={urlForm.method} onChange={e => setUrlForm(prev => ({ ...prev, method: e.target.value }))} className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400">
                  {HTTP_METHODS.map(m => (<option key={m} value={m}>{m}</option>))}
                </select>
              </div>
              <FormInput label="설명" value={urlForm.description} onChange={v => setUrlForm(prev => ({ ...prev, description: v }))} placeholder="예) 예약 목록 조회" />
            </InlineForm>
          )}
          */}
        </PanelCard>
      </div>
    </div>
  );
}

// ─── 서브 컴포넌트 ────────────────────────────────────────────────────────────

function PanelCard({
  icon,
  title,
  onAdd,
  disabled,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  onAdd?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={`flex flex-col rounded-lg border border-gray-200 bg-white shadow-sm ${disabled ? 'opacity-60' : ''}`}>
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-700">
          <span className="text-primary-600">{icon}</span>
          <span className="truncate">{title}</span>
        </div>
        {/* TODO: 저장/삭제 버튼 활성화 시 onAdd 버튼 노출
        {onAdd && !disabled && (
          <button onClick={onAdd} className="flex items-center gap-1 rounded bg-primary-600 px-2 py-1 text-xs font-medium text-white hover:bg-primary-700">
            <Plus size={12} /> 추가
          </button>
        )}
        */}
        {/* onAdd prop은 활성화 시를 위해 유지 */}
        {onAdd && false && <span />}
      </div>
      <div className="flex-1 overflow-y-auto">{children}</div>
    </div>
  );
}

// TODO: 저장/삭제 버튼 활성화 시 주석 해제
// function ActionButton({ icon, title, danger, onClick }: { icon: React.ReactNode; title: string; danger?: boolean; onClick: (e: React.MouseEvent) => void; }) {
//   return (
//     <button title={title} onClick={onClick} className={`rounded p-1 text-xs hover:bg-gray-100 ${danger ? 'text-red-500 hover:text-red-700' : 'text-gray-400 hover:text-gray-600'}`}>
//       {icon}
//     </button>
//   );
// }
//
// function InlineForm({ title, onSave, onCancel, children }: { title: string; onSave: () => void; onCancel: () => void; children: React.ReactNode; }) {
//   return (
//     <div className="m-3 rounded-lg border border-primary-200 bg-primary-50 p-3">
//       <p className="mb-2 text-xs font-semibold text-primary-700">{title}</p>
//       <div className="space-y-2">{children}</div>
//       <div className="mt-3 flex justify-end gap-2">
//         <button onClick={onCancel} className="rounded px-3 py-1 text-xs text-gray-600 hover:bg-gray-100">취소</button>
//         <button onClick={onSave} className="rounded bg-primary-600 px-3 py-1 text-xs font-medium text-white hover:bg-primary-700">저장</button>
//       </div>
//     </div>
//   );
// }
//
// function FormInput({ label, value, onChange, placeholder }: { label: string; value: string; onChange: (v: string) => void; placeholder?: string; }) {
//   return (
//     <div className="space-y-1">
//       <label className="text-xs font-medium text-gray-600">{label}</label>
//       <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400" />
//     </div>
//   );
// }

function MethodBadge({ method }: { method: string }) {
  const colors: Record<string, string> = {
    GET: 'bg-blue-100 text-blue-700',
    POST: 'bg-green-100 text-green-700',
    PUT: 'bg-yellow-100 text-yellow-700',
    PATCH: 'bg-orange-100 text-orange-700',
    DELETE: 'bg-red-100 text-red-700',
  };
  return (
    <span className={`flex-shrink-0 rounded px-1.5 py-0.5 text-xs font-bold ${colors[method] ?? 'bg-gray-100 text-gray-600'}`}>
      {method}
    </span>
  );
}

function LoadingRow() {
  return (
    <div className="py-6 text-center text-sm text-gray-400">불러오는 중...</div>
  );
}

function EmptyRow({ text }: { text: string }) {
  return (
    <div className="py-6 text-center text-sm text-gray-400">{text}</div>
  );
}
